import { Field } from 'formik';
import { useContractManagerFieldQuery } from '../../generated/graphql';
import { useConcession } from '../../hooks/useConcession';
import { ContractConcessionOrganizationUser } from '../../types/types';
import { ContractUserAutocomplete } from '../ContractUserAutocomplete/ContractUserAutocomplete';

export default function ContractManagerField(props: ContractConcessionOrganizationUser) {
    const { disabled } = props
    const concession = useConcession()
    const { data } = useContractManagerFieldQuery({ fetchPolicy: "no-cache", variables: { concession: concession?.id } })

    const name = "contractUsers"
    const label = "Gestor Contrato"
    const options = data?.concessionUsers?.nodes || []
    const role = "CONTRACTMANAGER"

    return (
        <Field
            name={name}
            component={ContractUserAutocomplete}
            options={options}
            label={label}
            role={role}
            disabled={disabled}
        />
    )
}
